module.exports = __webpack_public_path__ + "img/qiu3.f8b57234.png";